import React, { useEffect, useState } from 'react'
import {
  Box,
  DialogContent,
  FormControl,
  FormControlLabel,
  FormLabel,
  Grid,
  Radio,
  RadioGroup
} from '@mui/material'
import PropTypes from 'prop-types'

import PayNow from '../../../assets/icons/app/PayNow.png'
import BankTransferIcon from '../../../assets/icons/circles-design/BankTransferIcon.png'
import CCPaymentIcon from '../../../assets/icons/circles-design/CCPaymentIcon.png'

export default function PaymentSelection({
  PAYMENT_METHODS,
  ALLOWED_METHODS,
  setPaymentMethod
}) {
  const [hasCreditCard, setHasCreditCard] = useState(false)
  const [gridLayout, setGridLayout] = useState({})
  useEffect(() => {
    setHasCreditCard(ALLOWED_METHODS.includes(PAYMENT_METHODS.CREDIT_CARD))
  }, [])
  useEffect(() => {
    setGridLayout(() =>
      hasCreditCard ? { xs: 2, sm: 4, md: 4 } : { xs: 2, sm: 6, md: 6 }
    )
  }, [hasCreditCard])

  return (
    <>
      <DialogContent
        sx={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center'
        }}
      >
        <FormControl>
          <FormLabel id='payment-radio-buttons' />
          <RadioGroup
            row
            aria-labelledby='payment-radio-buttons'
            defaultValue={PAYMENT_METHODS.BANK_TRANSFER}
            name='radio-buttons-group'
            onChange={(e) => setPaymentMethod(e.target.value)}
          >
            <Grid
              container
              spacing={{ xs: 4, md: 4 }}
              columns={{ xs: 2, sm: 8, md: 12 }}
            >
              <Grid item {...gridLayout}>
                <Box
                  display='flex'
                  flexDirection='column'
                  sx={{ alignItems: 'center', justifyContent: 'center' }}
                >
                  <img
                    src={BankTransferIcon}
                    alt='BankTransferIcon'
                    width='75px'
                  />
                  <FormControlLabel
                    value={PAYMENT_METHODS.BANK_TRANSFER}
                    control={
                      <Radio id='bankTransferBtn' data-cy='bankTransferBtn' />
                    }
                    label='Bank Transfer'
                    sx={{
                      whiteSpace: 'nowrap'
                    }}
                  />
                </Box>
              </Grid>
              {hasCreditCard && (
                <Grid item {...gridLayout}>
                  <Box
                    sx={{
                      display: 'flex',
                      flexDirection: 'column',
                      alignItems: 'center'
                    }}
                  >
                    <img
                      src={CCPaymentIcon}
                      alt='CreditCardPayment'
                      width='75px'
                    />
                    <FormControlLabel
                      value={PAYMENT_METHODS.CREDIT_CARD}
                      control={
                        <Radio
                          id='creditTransferBtn'
                          data-cy='creditTransferBtn'
                          disabled='true'
                        />
                      }
                      label='Credit Card'
                      sx={{
                        whiteSpace: 'nowrap'
                      }}
                    />
                  </Box>
                </Grid>
              )}

              <Grid item {...gridLayout}>
                <Box
                  sx={{
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center'
                  }}
                >
                  <img src={PayNow} alt='PayNow' height='75px' />
                  <FormControlLabel
                    value={PAYMENT_METHODS.PAYNOW}
                    control={
                      <Radio
                        id='paynowBtn'
                        data-cy='payNowBtn'
                        disabled='true'
                      />}
                    label='PayNow'
                    sx={{
                      whiteSpace: 'nowrap'
                    }}
                  />
                </Box>
              </Grid>
            </Grid>
          </RadioGroup>
        </FormControl>
      </DialogContent>
    </>
  )
}

PaymentSelection.propTypes = {
  PAYMENT_METHODS: PropTypes.obj,
  ALLOWED_METHODS: PropTypes.array,
  setPaymentMethod: PropTypes.func
}
